export default __webpack_public_path__ + "images/wegenwacht2eabbeb0b5120a1e3152e2cbf376acce.svg";